import { render, staticRenderFns } from "./VaultSetupCompleted.vue?vue&type=template&id=304dba34&scoped=true"
import script from "./VaultSetupCompleted.vue?vue&type=script&lang=js"
export * from "./VaultSetupCompleted.vue?vue&type=script&lang=js"
import style0 from "./VaultSetup.scss?vue&type=style&index=0&id=304dba34&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304dba34",
  null
  
)

export default component.exports